import { Injectable, Inject } from '@angular/core';
import { HerstellerService } from '../odata-services';
import { GridDataService } from './core/griddata.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class HerstellerDataService extends GridDataService {
    
  public odataService: HerstellerService;
  
  
    constructor(  @Inject(HerstellerService)  service: HerstellerService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }

}
